import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { usePortalNavigation } from '../../hooks/usePortalNavigation';
import { PortalsSideNavItem } from './PortalsSideNavItem';
import { SiteMenuNavItem } from './SiteMenuNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PortalsSideNav({
  history
}) {
  const {
    navItems,
    siteMenuData
  } = usePortalNavigation();
  return /*#__PURE__*/_jsx(View, {
    as: "nav",
    "aria-label": "Portal navigation",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "400",
      paddingBlockStart: "500",
      paddingBlockEnd: "400",
      children: [navItems.map(item => /*#__PURE__*/_jsx(PortalsSideNavItem, {
        item: item,
        history: history
      }, item.id)), siteMenuData && siteMenuData.items.length > 0 && /*#__PURE__*/_jsx(SiteMenuNavItem, {
        menuData: siteMenuData
      })]
    })
  });
}